import React, { lazy } from 'react';
import { CheckCircle } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function WhatYouGetSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const items = ['Ebook en PDF (lectura clara, directa, aplicable)', 'Plan de 14 días (10 minutos diarios)', 'Hojas imprimibles: Las 7 frases de autojuicio (diagnóstico)', 'Hojas imprimibles: Evidencia real (hechos vs sentencia)', 'Hojas imprimibles: Filtro 3-2-1 de prioridades', 'Hojas imprimibles: Mínimos viables por categoría', 'Hojas imprimibles: Ritual "Día Suficiente" (5 min)', 'BONUS: Tarjetas "Respuestas listas"'];
  return <section ref={ref} className="w-full bg-cream py-10 px-6 md:py-14" data-id="element-255">
      <div className={`max-w-4xl mx-auto fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-256">
        <div className="text-center mb-8" data-id="element-257">
          <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-2" data-id="element-258">
            Qué recibes
          </h2>
          <p className="font-sans text-lg text-text-muted" data-id="element-259">
            Silencia a la "Mamá Juez" (14 días) incluye:
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-260">
          <div className="w-full md:w-1/2" data-id="element-261">
            <div className="relative" data-id="element-262">
              <div className="absolute inset-0 bg-gold/20 blur-2xl rounded-full opacity-40" data-id="element-263"></div>
              <img src="https://cdn.magicpatterns.com/uploads/daRwLhkLWduhSxzd84PeoT/mockup.png" alt="Product Mockup" loading="lazy" width={400} height={500} className="relative z-10 w-full h-auto drop-shadow-xl rounded-lg" data-id="element-264" />
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-265">
            <ul className="space-y-3" data-id="element-266">
              {items.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-267">
                  <CheckCircle className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-268" />
                  <span className="font-sans text-text-dark" data-id="element-269">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}